import React                from 'react';
import { Observe }               from 'rewire-core';
import { WithStyle, withStyles } from 'rewire-ui';
import { Theme }                 from '@material-ui/core/styles';
import SummaryListView           from './SummaryListView';
import timecardModeModel         from './TimecardModeModel';
import timecardPageModel         from './TimecardPageModel';
import TimecardSummaryView       from './TimecardSummaryView';
import TimecardToolbar           from './TimecardToolbar';
import TimecardView              from './TimecardView';

const styles = (_theme: Theme) => ({
  root: {
    display: 'flex',
    flex: '1',
    flexDirection: 'column',
    overflow: 'hidden'
  },
  timecardView: {
    display: 'flex',
    flex: '1',
    flexDirection: 'row',
    overflowY: 'auto',
  },
  summaryList: {
  },
  timecard: {
  },
  timecardSummaryView: {
    display: 'flex',
    flex: '1',
    flexDirection: 'column',
    overflowY: 'auto',
  },
  timecardSummary: {
  },
});

interface ITimecardPageViewProps {
}

type TimecardPageViewProps = WithStyle<ReturnType<typeof styles>, ITimecardPageViewProps>;

class TimecardPageView extends React.PureComponent<TimecardPageViewProps> {
  constructor(props: TimecardPageViewProps) {
    super(props);
  }

  componentWillUnmount() {
    timecardPageModel.reset();
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <Observe render={() => {
          switch (timecardModeModel.mode) {
            case 'Summary':
              return (
                <div className={classes.timecardSummaryView}>
                  <TimecardSummaryView className={classes.timecardSummary} />
                </div>
              );

            default:
              return (
                < >
                <TimecardToolbar />
                <div className={classes.timecardView}>
                  <SummaryListView className={classes.summaryList} />
                  <TimecardView    className={classes.timecard} />
                </div>
                </>
              );
          }
        }} />
      </div>
    );
  }
}

export default withStyles<ITimecardPageViewProps, any>(styles, TimecardPageView);
